/**
 * Opens and closes FAQ answers. The animation itself is CSS (the panel row grows from 0fr to 1fr);
 * this only flips the open state and keeps aria-expanded in sync.
 */
class AvalonFaq extends HTMLElement {
  #items = [];

  connectedCallback() {
    this.#items = Array.from(this.querySelectorAll('[data-item]'));
    this.addEventListener('click', this.#onClick);
    document.addEventListener('shopify:block:select', this.#onBlockSelect);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    document.removeEventListener('shopify:block:select', this.#onBlockSelect);
  }

  #set(item, open) {
    item.classList.toggle('is-open', open);
    item.querySelector('[data-trigger]')?.setAttribute('aria-expanded', String(open));
  }

  #onClick = (event) => {
    const trigger = event.target.closest('[data-trigger]');
    if (!trigger) return;

    const item = trigger.closest('[data-item]');
    const open = !item.classList.contains('is-open');

    if (open && this.dataset.single === 'true') {
      this.#items.forEach((other) => {
        if (other !== item) this.#set(other, false);
      });
    }

    this.#set(item, open);
  };

  #onBlockSelect = (event) => {
    const item = event.target.closest?.('[data-item]');
    if (!item || !this.contains(item)) return;

    this.#set(item, true);
  };
}

if (!customElements.get('avalon-faq')) {
  customElements.define('avalon-faq', AvalonFaq);
}
